export default __webpack_public_path__ + "static/media/Damaso_No34_Open.bbb01f59.jpg";